import React, { useEffect } from 'react'
import { TextInput, TextInputProps, View, ViewStyle } from 'react-native'

import { colors, Icon, Stack } from '@zet/design-system'

import { B14, M14 } from '../typography'

interface IProps {
  label: string
  placeholder: string
  onChange: (e: string) => void
  onBlur: () => void
  value: string
  keyboardType?: TextInputProps['keyboardType']
  maxLength?: number
  example: string
  errorMessage?: string
  isEditable?: boolean
  iconLeft?: React.ReactNode
  iconRight?: React.ReactNode
  style?: ViewStyle
  pointerEvents?: 'auto' | 'none' | 'box-none' | 'box-only'
  code?: string
  isAmount?: boolean
}

export const InputWithLabel: React.FC<IProps> = ({
  label,
  placeholder,
  onChange = () => null,
  onBlur,
  value,
  keyboardType,
  maxLength,
  example,
  errorMessage,
  isEditable = true,
  iconRight,
  iconLeft,
  style,
  pointerEvents,
  code,
  isAmount = false,
}) => {
  useEffect(() => {
    if (isAmount && value) {
      handleChange(value)
    }
  }, [value])

  const formatIndianCurrency = (numStr: string) => {
    const cleaned = numStr.replace(/[^0-9]/g, '')
    if (!cleaned) return ''
    const num = parseInt(cleaned, 10)
    if (isNaN(num)) return ''
    const x =
      cleaned.length > 3
        ? cleaned.slice(0, -3).replace(/\B(?=(\d{2})+(?!\d))/g, ',') +
          ',' +
          cleaned.slice(-3)
        : cleaned
    return x
  }

  const handleChange = (text: string) => {
    const formatted = formatIndianCurrency(text)
    onChange(formatted)
  }
  return (
    <View>
      <M14 className="mb-2">{label}</M14>

      <View className="relative">
        <View
          className={`flex-row items-center rounded-md bg-[#F6F7F8] px-2 ${
            errorMessage
              ? 'border-error-100 border'
              : 'border border-transparent'
          } ${
            code !== 'phoneNumber'
              ? 'focus-within:border-primary-100 focus-within:border-2'
              : ''
          }`}
          style={style}
        >
          {iconLeft && (
            <Icon type={iconLeft} color={colors.grays[80]} className="mr-2" />
          )}

          <TextInput
            pointerEvents={pointerEvents}
            editable={isEditable}
            onChangeText={isAmount ? handleChange : onChange}
            onBlur={onBlur}
            keyboardType={keyboardType}
            value={value}
            maxLength={maxLength}
            placeholder={placeholder}
            placeholderTextColor={'#1C1D1F'}
            className={`h-[45px] flex-1 rounded-md bg-transparent font-[JioType] ${
              code === 'phoneNumber' ? 'outline-none' : 'focus:outline-none'
            }`}
          />

          {iconRight && (
            <Icon type={iconRight} color={colors.grays[80]} className="ml-2" />
          )}
        </View>
      </View>

      {errorMessage ? (
        <Stack className="mt-2">
          <B14 className="text-error-100">{errorMessage}</B14>
        </Stack>
      ) : null}

      {!value && example ? (
        <B14 className="text-grays-80 mt-2">{example}</B14>
      ) : null}
    </View>
  )
}
